module.exports = __webpack_public_path__ + "img/strength_icon1.57951a1a.png";